import { Icon } from "armstrong-react";
import React from "react";
import { socialUrlBuilder } from "../../../shared/helpers/socialMediaHelpers";

import "./socialShare.scss";

interface ISocialShareProps {
  link: string;
  shortMessage: string;
  longMessage?: string;
  imageUrl?: string;
}

export class SocialShareIcons extends React.Component<ISocialShareProps, any> {
  public render() {
    const twitterUrl = socialUrlBuilder("twitter")(this.props.link, this.props.shortMessage);
    const facebookUrl = socialUrlBuilder("facebook")(this.props.link, this.props.shortMessage);
    const linkedInUrl = socialUrlBuilder("linkedin")(this.props.link, this.props.shortMessage, this.props.longMessage || this.props.shortMessage);
    const pinterestUrl = socialUrlBuilder("pinterest")(this.props.link, this.props.shortMessage, this.props.imageUrl);

    return (
      <div className="social-share-icons">
        <a href={twitterUrl} target="_blank">
          <Icon className="twitter" icon={Icon.Icomoon.twitter2} />
        </a>
        <a href={facebookUrl} target="_blank">
          <Icon className="facebook" icon={Icon.Icomoon.facebook2} />
        </a>
        <a href={linkedInUrl}>
          <Icon className="linkedin" icon={Icon.Icomoon.linkedin} />
        </a>
         <a href={pinterestUrl}>
          <Icon className="pinterest" icon={Icon.Icomoon.pinterest2} />
        </a>
      </div>
    );
  }
}
